import cn from "classnames"

import { Flex, Spin } from "@/atoms"

import styles from "./Loader.module.scss"

interface LoaderProps {
  className?: string
}

export const Loader = ({ className }: LoaderProps) => (
  <Flex
    className={cn(styles.container, className)}
    flex={1}
    align="center"
    justify="center"
  >
    <Spin />
  </Flex>
)
